module.exports = __webpack_public_path__ + "static/video-8eef482576f063d32ac077a049ac2eb0.png";